/*** IMPORTS FROM imports-loader ***/
var global = window;

export default {
  disabled: false
};
